import { swizzle as _swizzle } from "@thi.ng/arrays";
import { isIterable } from "@thi.ng/checks";
import { iterator1 } from "../iterator";
import { map } from "./map";
export function swizzle(order, src) {
    return isIterable(src)
        ? iterator1(swizzle(order), src)
        : map(_swizzle(order));
}
